import "../App.css";
import React from 'react'
import picture from "../Images/propic3.png";

const Home = () => {
  return (
    <div className='home'>
      <div className='bluePart'>
        <h1>Prudhvi</h1>
        <h2>Full Stack<br/>Developer</h2>
        <p>I like to craft solid websites using <br/> MERN stack.</p>
      </div>
      <div className='yellowPart'>
        <img src={picture} alt="myPicture"/>
      </div>
    </div>
  )
}

export default Home